/* eslint-disable camelcase */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const PaymentDetailsInfo = ({ amount, processing, totalDiscount, totalMoney }) => {
  return (
    <div className="booking-payment-details-info my-5 md:w-3/4 mx-auto">
      <h2 className="text-2xl font-semibold text-center">Payment Details</h2>
      <div className="table my-5 border-b w-full">
        <ul className="header flex items-start justify-between">
          <li className="w-1/3 font-semibold">Description</li>
          <li className="w-1/3 font-semibold">Quantity</li>
          <li className="w-1/3 font-semibold">Unit Price</li>
        </ul>
        <ul className="data flex items-start justify-between my-3">
          <li className="w-1/3 font-light">Proposal</li>
          <li className="w-1/3 font-light">1</li>
          <li className="w-1/3 font-light">{totalMoney}</li>
        </ul>
      </div>
      <div className="flex justify-around">
        <p className="font-bold text-lg">Discount</p>
        <p className="font-bold text-lg">{totalDiscount}</p>
      </div>
      <div className="flex justify-around">
        <p className="font-bold text-lg">Amount Due</p>
        <p className="font-bold text-lg">{amount}</p>
      </div>
      <div className="flex justify-center mt-10">
        <button
          disabled={processing}
          className={`btn-primary px-12 py-3 rounded-lg ${
            processing && 'bg-secondary-graywhite cursor-not-allowed text-primary-lightgray'
          }`}
          type="submit"
        >
          {processing ? 'Confirming Payment...' : 'Confirm Payment'}
        </button>
      </div>
    </div>
  )
}

PaymentDetailsInfo.propTypes = {
  amount: PropTypes.string,
  processing: PropTypes.bool.isRequired,
  totalDiscount: PropTypes.string,
  totalMoney: PropTypes.string,
}

const mapStateToProps = ({ bookings, promocodes }) => {
  const totalMoney = `${bookings.bookingDetails.currency} ${bookings.bookingDetails.amount}`
  const currency = promocodes?.promo_discount?.promotion?.currency || ''
  let amount = `${bookings.bookingDetails.currency} ${bookings.bookingDetails.amount}`
  const promotionValid = promocodes?.promo_discount?.valid || false
  const totalDiscount = `${currency} ${promocodes?.promo_discount?.promotion?.total_discount || 0}`
  if (promotionValid) {
    amount = `${currency} ${promocodes.promo_discount.promotion.total_need_to_pay}`
  }
  return {
    processing: bookings.processing,
    totalDiscount,
    amount,
    totalMoney,
  }
}

export default connect(mapStateToProps)(PaymentDetailsInfo)
